import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "link" }

import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccessibilitySection',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('appStore.accessibilityTitle')), 1),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref(t)('appStore.accessibilityBody')) + " ", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('appStore.learnMore')), 1)
    ])
  ]))
}
}

})